module.exports = __webpack_public_path__ + "img/IMG_20130404_124914.198939d9.jpg";